import { DataTable } from 'bricks-ui/packages/bricks-ui';

export default DataTable;
